import { 
    USER_LOGIN_FAILURE,
    USER_LOGGED_IN, USER_LOGGED_OUT, 
 } from '../actions/auth'

 import config from '../config'

const access_token = localStorage.getItem(config.access_key)
const refresh_token = localStorage.getItem(config.refresh_key)

const initailState = {
    access_token: access_token ? access_token : null,
    refresh_token: refresh_token ? refresh_token : null,
}

export default (state = initailState, action) => {
    switch (action.type) {
        case USER_LOGGED_IN:
            return {
                access_token: action.payload.access_token,
                refresh_token: action.payload.refresh_token,
            }
        case USER_LOGIN_FAILURE:
        case USER_LOGGED_OUT:
            return {
                access_token: null,
                refresh_token: null,
            }
        default:
            return state
    }
}